<template>
  <div>
    <!-- AppNavbar -->
    <app-navbar></app-navbar>

    <!-- Dashboard Container -->
    <div class="dashboard-container">
      <!-- AppSidebar -->
      <app-sidebar></app-sidebar>

      <slot></slot>
      <!-- <app-footer></app-footer> -->
    </div>
    <!-- Dashboard Container / End -->
  </div>
</template>

<script>
  import { AppNavbar, AppSidebar } from '../../partials/user-dashboard';
  export default {
    name: 'UserDashboard',
    components: {
      AppNavbar,
      AppSidebar,
      // AppFooter,
    },
  };
</script>

<style></style>
